<template>
  <div class="login-header">
    <table>
       <tbody>
        <tr>
          <td class="login-header-logo">
            <el-image :src="require('@/assets/images/Enea.logo.png')" />
          </td>
          <td class="login-header-name">
            <h1>{{ t('headers.NavbarTitleBegin') }}</h1>
            <h2>{{ t('headers.NavbarTitle') }}</h2>
          </td>
        </tr>
       </tbody>
    </table>
  </div>
</template>

<script>
import $ from 'jquery'
import { t } from '@/setup/i18n-setup'

export default {
  name: 'PasswordPageHeader',
  
  setup() {
    return {};
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  created() {

  },
  computed: {

  },
  methods: {
        t,

  },
  watch: {

  }
}
</script>
